<script>
    import {enhance} from "$app/forms";
    import {cart} from "$lib/state/cart";
    import {
        ADD_TO_CART_EVENT,
        DELETE_ITEM_FROM_CART_EVENT,
        REMOVE_FROM_CART_EVENT,
        dispatchCustomEvent,
    } from "$lib/utils/events";

    export let itemId = 0;
    export let qty = 0;
    export let sku = "";
    export let size = "";

    let signalController = new AbortController();
    let fetchInProgress = false;

    /** @param {number} newQty*/
    async function updateProductQty(newQty) {
        if (newQty < 0) {
            return;
        }

        let method = "PUT";

        if (newQty === 0) {
            method = "DELETE";
        }

        const oldQty = qty;

        qty = newQty;

        if (fetchInProgress) {
            signalController.abort();
            signalController = new AbortController();
        }
        const formData = new FormData();
        formData.set("itemId", String(itemId));
        formData.set("qty", String(newQty));
        formData.set("sku", sku);

        try {
            fetchInProgress = true;
            const responseStream = await fetch(`/cart?itemId=${itemId}`, {
                signal: signalController.signal,
                method,
                body: formData,
            });
            fetchInProgress = false;

            const response = await responseStream.json();

            if (responseStream.status === 200) {
                switch (method) {
                    case "PUT":
                        const sendQty = newQty - oldQty;
                        if (sendQty > 0) {
                            dispatchCustomEvent(
                                ADD_TO_CART_EVENT,
                                response.cart,
                                sku,
                                sendQty
                            );
                        } else {
                            dispatchCustomEvent(
                                REMOVE_FROM_CART_EVENT,
                                response.cart,
                                sku,
                                sendQty * -1
                            );
                        }
                        break;
                    case "DELETE":
                        dispatchCustomEvent(DELETE_ITEM_FROM_CART_EVENT, $cart, itemId);
                        break;
                }
                /** @type {import('magento-gql-types').Cart} */
                (response.cart);
                cart.set(response.cart);
                return;
            }

            throw new Error(/** @type {any} */ (response));
        } catch (error) {
            if (/** @type {Error} */ (error).name !== "AbortError") {
                console.error(error);
            }
        }
    }

    let showUpdateButton = false;

    function onSubmit() {
        showUpdateButton = false;
        // @ts-ignore
        return ({result, update}) => {
            if (result.status === 200) {
                // @ts-ignore
                cart.set(result.data.cart);
            }
            update();
        };
    }

    /**@param {number}newQty*/
    const updateQty = (newQty) => (qty = newQty);
</script>

<div class={`cart-qty ${size}`} aria-roledescription={`${sku} cart qty`}>
    <button
            type="button"
            aria-labelledby="action_decrease"
            on:click={() => {
      if (size === "min") {
        updateProductQty(qty - 1);
      } else {
        updateQty(qty - 1);
      }
    }}
    >
    <span id="action_decrease" class="label">
      Decrease item quantity in cart
    </span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 18">
            <text
                    id="_"
                    data-name="+"
                    transform="translate(0 13)"
                    font-size="18"
                    font-family="sirenia"
            >
                <tspan x="0" y="0">-</tspan>
            </text>
        </svg>
    </button>
    <div class="qty">
        <form
                id={`update-${itemId}-qty`}
                action="/cart?/updateCartQty"
                method="post"
                use:enhance={onSubmit}
        >
            <input type="hidden" name="itemId" value={itemId}/>
            <input
                    type="text"
                    name="qty"
                    id={`cart-qty-${sku}`}
                    value={qty}
                    on:change={() => (showUpdateButton = true)}
            />
            <label for={`cart-qty-${sku}`}>{sku} quantity in cart</label>
        </form>
    </div>
    <button
            type="button"
            aria-labelledby="action_increase"
            on:click={() => {
      if (size == "min") {
        updateProductQty(qty + 1);
      } else {
        updateQty(qty + 1);
      }
    }}
    >
    <span id="action_increase" class="label">
      Increase item quantity in cart
    </span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 18">
            <text
                    id="_"
                    data-name="-"
                    transform="translate(0 13)"
                    font-size="16"
                    font-family="sirenia"
            >
                <tspan x="0" y="0">+</tspan>
            </text>
        </svg>
    </button>
    {#if showUpdateButton}
        <button
                form={`update-${itemId}-qty`}
                type="submit"
                class="update-qty-button"
        >
            Update
        </button>
    {/if}
</div>

<style>
    button {
        background: none;
        border: none;
        padding: none;
        margin: none;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .cart-qty {
        --button-width: 16px;
        --component-width: 130px;
    }

    .cart-qty.min {
        --button-width: 11px;
        --component-width: 94px;
    }

    button svg {
        width: var(--button-width);
    }

    .cart-qty {
        display: grid;
        grid-template-columns:
      calc(var(--component-width) * 0.2) auto calc(var(--component-width) * 0.2)
      auto;
        gap: 5px;
        width: var(--component-width, 90px);
        align-content: center;
    }

    .qty {
        display: contents;
    }

    .qty input {
        background: none;
        border: none;
        text-align: center;
        color: #000;
        font-size: 1.3rem;
        font-weight: 500;
        width: 100%;
    }

    .qty label {
        position: absolute;
        left: -10000px;
        top: auto;
        width: 1px;
        height: 1px;
        overflow: hidden;
    }

    .update-qty-button {
        font-size: 1.5rem;
        color: blue;
    }
</style>
